<app-generic-container>
  <!-- Usamos el panel genérico -->
  <app-generic-panel [title]="'Usuario'" [description]="" [icon]="'person'">
    <ng-container *ngIf="model">
      <form class="form-horizontal" (ngSubmit)="onSubmit(formUsuario)" #formUsuario="ngForm" novalidate>

        <!-- <app-form-input-layout [labelText]="'Nombre de usuario'" [isRequired]="true">
          <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.UserName" name="UserName"
            required>
        </app-form-input-layout> -->

        <ng-container *ngIf="isNew">
          <app-form-input-layout [labelText]="'Contraseña'" [isRequired]="true">
            <input class="form-control" autocomplete="off"
              pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!¡*()@%&]).{6,}$" type="Password"
              [(ngModel)]="model.Password" name="Password" required validateEqual="ConfirmPassword" reverse="true"
              #Password="ngModel">
            <ng-container *ngIf="Password.invalid  && (Password.dirty || Password.touched)">
              <small *ngIf="Password.errors.required" class="text-danger">
                La contraseña es obligatoria
              </small>
              <small *ngIf="Password.errors?.pattern" class="text-danger">
                Las contraseñas deben tener al menos 6 caracteres, y debe contener al menos un carácter que no sea una
                letra ni un dígito,
                una letra en minúscula ('a'-'z') y una letra en mayúscula ('A'-'Z').
              </small>
            </ng-container>
          </app-form-input-layout>

          <app-form-input-layout [labelText]="'Confirmar contraseña'" [isRequired]="true">
            <input type="Password" class="form-control" name="ConfirmPassword" [ngModel]="model.ConfirmPassword"
              required validateEqual="Password" reverse="false" #ConfirmPassword="ngModel">
            <small [hidden]="ConfirmPassword.valid || (ConfirmPassword.pristine && !formUsuario.submitted)"
              class="text-danger">
              La contraseña no coincide
            </small>
          </app-form-input-layout>
        </ng-container>

        <app-form-input-layout [labelText]="'Nombre'" [isRequired]="true">
          <input class="form-control" type="text" [(ngModel)]="model.Name" name="Nombre" required>
        </app-form-input-layout>

        <app-form-input-layout [labelText]="'Apellidos'" [isRequired]="true">
          <input class="form-control" type="text" [(ngModel)]="model.Surname" name="Apellidos" required>
        </app-form-input-layout>

        <app-form-input-layout [labelText]="'Email'" [isRequired]="true">
          <input class="form-control" type="email" [(ngModel)]="model.Email" name="Email" required>
        </app-form-input-layout>

        <app-form-input-layout [labelText]="'Desactivado'" *ngIf="!isNew">
          <dx-check-box [(value)]="model.IsDeleted"></dx-check-box>
        </app-form-input-layout>

        <app-form-input-layout [labelText]="'Roles'" [isRequired]="true">

          <mat-form-field>
            <mat-select data-size="7" [(ngModel)]="model.Roles" multiple name="Roles" required>
              <mat-option *ngFor="let rol of roles" [value]="rol">
                {{rol}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </app-form-input-layout>

        <!-- <app-form-input-layout [labelText]="'Empresas'">

          <mat-form-field>
            <mat-select data-size="7" [(ngModel)]="userA3LCompanies" multiple name="Companies">
              <mat-option *ngFor="let company of a3LCompanies" [value]="company.companyCode">
                {{company.companyName}}
              </mat-option>
            </mat-select>
          </mat-form-field>

        </app-form-input-layout> -->

        <!-- Botonera -->
        <div class="row">
          <label class="col-md-3"></label>
          <div class="col-md-9">
            <div class="form-group form-button">
              <button class="btn btn-fill btn-success" type="submit" [disabled]="!formUsuario.valid">Guardar</button>
              <a class="btn btn-fill btn-danger" routerLink="../">Cancelar</a>
            </div>
          </div>
        </div>

      </form>

    </ng-container>
  </app-generic-panel>


  <app-generic-panel [title]="'Permisos sobre empresas'" [description]="" [icon]="'key'" *ngIf="!isNew">
      <form class="form-horizontal" (ngSubmit)="onSubmitPermisosSobreEmpresas(formPermisos.valid)"
        #formPermisos="ngForm" novalidate>

        <div class="row">
          <label _ngcontent-sfw-c58="" class="col-md-3 col-form-label text-md-right">Empresas
            <span _ngcontent-sfw-c58="" class="star ng-star-inserted">*</span>
          </label>

          <app-company-selector dataSize="7" [(ngModel)]="selectedCompanies" class="col-md-9" name="selectedCompanies"
            [required]="false" [onlyConfigured]="true" [multiple]="true"></app-company-selector>

        </div>

          <!-- Botonera -->
        <div class="row">
          <label class="col-md-3"></label>
          <div class="col-md-9">
            <div class="form-group form-button">
              <button class="btn btn-fill btn-success" type="submit" [disabled]="!formPermisos.valid">Guardar</button>
            </div>
          </div>
        </div>

      </form>
  </app-generic-panel>

  <app-generic-panel [title]="'Contraseña'" [description]="" [icon]="'security'" *ngIf="!isNew">
    <ng-container *ngIf="setPasswordModel">
      <form class="form-horizontal" (ngSubmit)="onSubmitFormPassword(formPassword.value, formPassword.valid)"
        #formPassword="ngForm" novalidate>
        <app-form-input-layout [labelText]="'Contraseña'" [isRequired]="true">
          <input class="form-control" autocomplete="off"
            pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!¡*()@%&]).{6,}$" type="Password"
            [(ngModel)]="setPasswordModel.NewPassword" name="NewPassword" required validateEqual="ConfirmPassword"
            reverse="true" #Password="ngModel">
          <ng-container *ngIf="Password.invalid  && (Password.dirty || Password.touched)">
            <small *ngIf="Password.errors.required" class="text-danger">
              La contraseña es obligatoria
            </small>
            <small *ngIf="Password.errors.pattern" class="text-danger">
              Las contraseñas deben tener al menos 6 caracteres, y debe contener al menos un carácter que no sea una
              letra ni un dígito,
              una letra en minúscula ('a'-'z') y una letra en mayúscula ('A'-'Z').
            </small>
          </ng-container>
        </app-form-input-layout>

        <app-form-input-layout [labelText]="'Confirmar contraseña'" [isRequired]="true">
          <input type="Password" class="form-control" name="ConfirmPassword"
            [ngModel]="setPasswordModel.ConfirmPassword" required validateEqual="NewPassword" reverse="false"
            #ConfirmPassword="ngModel">
          <small [hidden]="ConfirmPassword.valid || (ConfirmPassword.pristine && !formPassword.submitted)"
            class="text-danger">
            La contraseña no coincide
          </small>
        </app-form-input-layout>

        <!-- Botonera -->
        <div class="row">
          <label class="col-md-3"></label>
          <div class="col-md-9">
            <div class="form-group form-button">
              <button class="btn btn-fill btn-success" type="submit" [disabled]="!formPassword.valid">Cambiar
                Password</button>
            </div>
          </div>
        </div>

      </form>

    </ng-container>
  </app-generic-panel>
</app-generic-container>
